<template>
  <div id="contenedor-eliminar-minuta-acuerdo">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Acuerdo </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el acuerdo? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{minutaAcuerdoEliminar.numero}}
          </span>
        </v-row>
         <v-row>
          <span> <cortar-texto
          :texto="minutaAcuerdoEliminar.descripcion">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarMinutaAcuerdo"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixAcuerdos from './mixAcuerdos';

export default {
  name: 'ContenedorEliminarMinutaAcuerdo',
  props: {
    minutaAcuerdoEliminar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixAcuerdos],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarMinutaAcuerdo() {
      this.mixEliminarAcuerdo();
    },
  },
  computed: {
    tieneDependencias() {
      return false;
    },
  },
};
</script>
